export default "__VITE_ASSET__BYC6eRNQ__"